module.exports = __webpack_public_path__ + "img/home-dog-3.e52389ba.jpg";